import React from 'react'

const Elle = props => (
  <svg viewBox="0 0 737 266" {...props}>
    <path
      d="M270.847 262.241h-12.782V4.131h19.901V.724H206.69v3.409h19.864v258.11H206.69v3.365h113.3v-69.622h-3.358c-.726 45.943-19.898 66.256-45.785 66.256m210.091 0h-12.744V4.131h19.864V.724h-71.274v3.409h19.859v258.11h-19.859v3.365h113.3v-69.622h-3.357c-.73 45.943-19.899 66.256-45.789 66.256m-421.277 0H49.104V132.448h4.529c17.636 0 27.02 18.792 27.02 47.398h2.993V79.756h-2.993c0 24.446-8.253 49.281-27.02 49.281h-4.529V4.132h13.508c21.034 0 43.929 16.947 43.929 62.077h2.993V.723H.323v3.409h17.27v258.11H.323v3.365h109.615v-69.214h-2.993c0 48.901-24.754 65.848-47.284 65.848m673.8-65.973c0 48.947-24.754 65.854-47.284 65.854h-10.515V132.324h4.486c17.637 0 27.021 18.814 27.021 47.403h3.03V79.63h-3.03c0 24.452-8.25 49.287-27.02 49.287h-4.487V4.028h13.466c21.071 0 43.93 16.931 43.93 62.08h3.034V.62H626.836v3.406h17.275v258.095h-17.275v3.366h109.618v-69.22h-2.993"
      fill="#eeefe6"
    />
  </svg>
)

export default Elle
